var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClockFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 25 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.55 12.78h8.381v-1.561h-6.828V.01c6.292.374 11.28 5.594 11.28 11.986 0 6.635-5.374 12.014-12.003 12.014C5.751 24.01.377 18.63.377 11.996.377 5.64 5.309.443 11.55.016V12.78Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClockFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ClockFilled.9306411aee0a7858e9989448216514f2.svg";